module.exports = __webpack_public_path__ + "static/media/bell-school.28e9659b.svg";